import { menuItems, menuItemsIndex } from "../../const/Menu/MenuConst";
import { VideoString } from "../../const/assets/VideoString";
import {
  TransitionType,
  HotspotType,
  HotspotButtonType,
  StaticLinks,
} from "../../const/fixed/Types";
import { ImageString } from "../../const/assets/ImageString";
import {
  LobbyStall1PdfPlayer,
  LobbyStall1VideoPlayer,
  LobbyStall1BusinessCardPlayer,
} from "./realtimeData";
import { isIOS, isMobileOnly } from "react-device-detect";

export let InfoHotspots = {
  inLinevideo: {
    id: "product-video",
    get enabled() {
      return !isMobileOnly ? true : false;
    },
    name: "Stall Video",
    style: {
      margin: "13.7% 37.1%",
      // width: "27.9%",
      // height: "37.2%",
      width: "calc(58vh)",
      height: "calc(33vh)",
    },
    hotspotType: HotspotType.inlineVideo,
    buttonType: HotspotButtonType.named,
    link: "https://www.youtube.com/embed/BF5C3sxdewI",
  },
  video: {
    id: "product-video",
    get enabled() {
      return isMobileOnly ? true : false;
    },
    name: "Stall Video",
    desk_style: {
      margin: "5% 27%",
    },
    mobile_style: {
      margin: "-5% 0.5%",
    },
    get style() {
      return isMobileOnly ? this.mobile_style : this.desk_style;
    },
    hotspotType: HotspotType.video,
    buttonType: HotspotButtonType.default,
    link: "https://www.youtube.com/embed/BF5C3sxdewI",
  },
};

export let LobbyStall1Hotspot = {
  stallChat: {
    id: "intelStallChat",
    enabled: true,
    name: "Live Chat",
    style: {
      margin: "8.5% -6.8%",
    },
    hotspotType: HotspotType.stallChat,
    roomDetails: {
      id: "LobbyStall1",
    },
    buttonType: HotspotButtonType.named,
    customAnalytics: {
      path: "/lobbyStall1",
      id: "stallChat",
    },
  },
  stallCall: {
    id: "stallCall",
    enabled: true,
    name: "Video Call",
    style: {
      margin: "8.5% 2.2%",
    },

    hotspotType: HotspotType.videoCall,
    roomDetails: {
      id: "lobbystall1",
    },
    buttonType: HotspotButtonType.named,
    customAnalytics: {
      path: "/lobbyStall1",
      id: "stallCall",
    },
  },
};

export let AudiData = {
  introVideo: VideoString.AUDITORIUM,
  link: "https://vimeo.com/event/473964",
  rmtpURL: "",
  showImage: false,
  imageLink: "",
  placementStyle: { margin: "16.1% 35.38%", width: "28.5%", height: "37.2%" },
  streamLink: "https://streamyard.com/fpupwvz8ku",
};
export let LabData = {
  introVideo: VideoString.BREAKOUTLOOP,
  link: "https://vimeo.com/event/473964",
  placementStyle: { margin: "14.65% 39%", width: "20.9%", height: "27.5%" },
};
export let DBRData = {
  introVideo: VideoString.DBRLOOP,
  link: "https://vimeo.com/event/473964",
  placementStyle: { margin: "14.65% 39%", width: "25.9%", height: "27.5%" },
  zoomlink: "",
};
export let links = {
  faceyoga: "/assets/content/sample.pdf",
  gamezone: "/assets/content/sample.pdf",
  igfilter: "/assets/content/sample.pdf",
  infodesk: "/assets/content/sample.pdf",
  pressroom: "/digitalRack/index.html",
};
export let TeamsData = {
  "pdf-1": {
    id: "pdf=1",
    name: "ABOUT THE ACTIVITY",
    description: "",
    link: "/assets/content/TeamBuildingInfo.pdf",
    button: "READ MORE",
  },
  link1: {
    id: "link1",
    name: "Team Leadership",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_ODFmOTI3MTUtZTFmNy00NTgwLWExMzItOTI2MzkyNmFmYTlk%40thread.v2/0?context=%7b%22Tid%22%3a%2225c1df4b-00ea-4e39-98bd-5f1143c5c5df%22%2c%22Oid%22%3a%22abcb8352-f7bf-475a-82d7-cb6c48c7d70f%22%7d",
  },
  link2: {
    id: "link2",
    name: "Team Mindset",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    link: "https://www.r1rcm.com/",
  },
  link3: {
    id: "link3",
    name: "Team Values",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    link: "https://www.r1rcm.com/",
  },
  link4: {
    id: "link4",
    name: "Team Rising",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    link: "https://www.r1rcm.com/",
  },
  link5: {
    id: "link5",
    name: "Team Leadership",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    link: "https://www.r1rcm.com/",
  },
  link6: {
    id: "link6",
    name: "Team Mindset",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    link: "https://www.r1rcm.com/",
  },
  link7: {
    id: "link7",
    name: "Team Values",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    link: "https://www.r1rcm.com/",
  },
  link8: {
    id: "link8",
    name: "Team Rising",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    link: "https://www.r1rcm.com/",
  },
  link9: {
    id: "link9",
    name: "Team Values",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    link: "https://www.r1rcm.com/",
  },
  link10: {
    id: "link10",
    name: "Team Rising",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    link: "https://www.r1rcm.com/",
  },
};
// /web/viewer.html?file=%2F
export const LobbyHotspotsId = {
  Survey: "Survey",
  Twitter: "Twitter",
  Audi: "Audi",
  Networking: "Networking",
  Infodesk: "Infodesk",
  Agenda: "Agenda",
  LobbyStall1: "LobbyStall1",
  DBR: "DBR",
  LeadersProfile: "LeadersProfile",

  PreLobby: "PreLobby",
  Lobby: "Lobby",
  Game: "Game",
  PhotoBooth: "PhotoBooth",
  LeaderBoard: "LeaderBoard",
};

export let LobbyHotspots = {
  [LobbyHotspotsId.Lobby]: {
    id: LobbyHotspotsId.Lobby,
    enabled: true,
    style: {
      margin: isIOS ? "-2% -4.5%" : "-3% -4.5%",
    },
    hotspotType: HotspotType.transition,
    transitionVideo: VideoString.LOBBYTOAudi,
    transitionType: TransitionType.changeComponent,
    newItem: menuItems[menuItemsIndex.Lobby],
  },

  [LobbyHotspotsId.LeaderBoard]: {
    id: LobbyHotspotsId.LeaderBoard,
    enabled: false,
    style: {
      margin: "-20% -3%",
    },
    hotspotType: HotspotType.transition,
    transitionVideo: null,
    transitionType: TransitionType.changeComponent,
    newItem: menuItems[menuItemsIndex.LeaderBoard],
  },

  [LobbyHotspotsId.PhotoBooth]: {
    id: LobbyHotspotsId.PhotoBooth,
    enabled: true,
    style: {
      margin: isIOS ? "6% 1%" : "6% 1%",
    },
    hotspotType: HotspotType.iframe,
    link: "/photobooth/index.html",
  },
};

export let NetworkingLounge = {
  speakerPdf: "/web/viewer.html?file=%2Fassets%2Fcontent%2FSpeakers.pdf",
};
